import React, { Component } from 'react';
import styles from './styles';
import { css } from 'aphrodite';
import check from 'assets/images/check.svg';
import add from 'assets/images/add.svg';
import { Product } from 'library';

class ProductButton extends Component {

    render() {
        const { product, linkTitle, onOpenProduct, onSelectProduct, isOpened, isSelected, dataLayer, selectedProduct, imgUrl } = this.props;
        return (
            <div className={css(styles.productButton)}>
                <div className={css(styles.productButtonInner, isSelected ? styles.selected : isOpened ? styles.openedButton : '')} onClick={onOpenProduct}>
                    <span className={css(styles.span)}>{product.entity.entityLabel}</span>
                    { isSelected && <img className={css(styles.check)} src={ imgUrl + check } alt=""/>}
                </div>
                <div className={css(styles.productContainer, isOpened ? styles.openedProduct : '')}>
                    <Product data={product} lightVersion style={styles.product} linkTitle={linkTitle} dataLayer={dataLayer} selectedProduct={selectedProduct} />
                </div>
                <div className={css(styles.productSelectionButton, isOpened ? styles.opened : '')} onClick={onSelectProduct}>
                    <img className={css(styles.add)} src={ imgUrl + add } alt=""/>
                    <span>Select this product</span>
                </div>
            </div>
        );
    }
}

export default ProductButton;